// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"fbf5368a","240":"6ec121d0","453":"d4ead90d","468":"3fcf6abe","529":"7fed1785","552":"c827d6ec","581":"6c3066a4","669":"4644e41b","823":"7e711083","869":"bce63a16"}[chunkId] + ".chunk.js";
};